export default class HomeEnum {
    static IRIS_COLLECTION_CUSTOMER_DOMAIN = 'theme_customer'

    static SEARCH_ENGINE_FORM = '[data-engine-form]'
    static SEARCH_ENGINE_STARTDATE = '[data-engine-field="startdate"]'
    static SEARCH_ENGINE_ENDDATE = '[data-engine-field="enddate"]'
}
